import MainMenuPage from "./MainMenuPage/MainMenuPage"

export default MainMenuPage
